/**
 * Listado de guías de residuos. Alta nueva: generador unificado (ver `../legacy/README.md`).
 */
import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';

//redux
import GuidesList from './GuidesList';

const Guides = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio' },
		{ to: '#', label: 'Medio Ambiente' },
		{ to: '/residue/dashboard', label: 'Residuos' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title="Guías de Residuos" plinks={breadcrumbLinks} />
					<GuidesList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Guides;
